export default {
  ru: {
    label: 'ФИО',
    placeholder: 'Введите ваше ФИО',
    error: 'ФИО введено неверно',
  },
  en: {
    // en
  },
};
